module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/price_game-efc0253ea500a9fc1e2bc33a62994665.jpg";